import React from 'react';
import { BookingPill } from '../../BookingPill';
import {
  addDays,
  startOfDay,
  endOfDay,
  fmtDayShort,
  fmtTime,
  colourFor,
} from '../../../lib/diary/helpers';

// ===== WEEK VIEW =====
export const WeekView = ({ weekStart, bookings, isFirstForCustomer, onPickDay, onOpenBooking }) => {
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
  // 7 columns each with a 100 px minimum so on <900 px screens the grid
  // horizontally scrolls instead of collapsing into unreadable slivers.
  // Item 42 — the tester flagged that on mobile the week columns were
  // 40-50 px wide and all content overflowed. `.cal-week-grid` is the
  // scrolling container; on desktop the min-width still fits inside the
  // parent so no horizontal scrollbar appears.
  const gridStyle = { gridTemplateColumns: 'repeat(7, minmax(100px, 1fr))' };
  return (
    <div className="cal cal-week-scroll" data-testid="cal-week">
      <div className="cal-week-grid">
        <div className="cal-head" style={gridStyle}>
          {days.map(d => (
            <div key={d.toISOString()} style={{ cursor: 'pointer' }} onClick={() => onPickDay(d)}>
              {fmtDayShort(d)}
            </div>
          ))}
        </div>
        <div style={{ display: 'grid', ...gridStyle, minHeight: 320 }}>
          {days.map(d => {
            const sod = startOfDay(d).getTime();
            const eod = endOfDay(d).getTime();
            const dayBks = bookings.filter(b => {
              const t = new Date(b.starts_at).getTime();
              return t >= sod && t <= eod;
            }).sort((a,b) => new Date(a.starts_at) - new Date(b.starts_at));
            return (
              <div key={d.toISOString()} style={{ borderLeft: '1px solid var(--line2)', padding: 8, minHeight: 320 }}>
                {dayBks.length === 0 && (
                  <div style={{ fontSize: 11.5, color: 'var(--mute2)', padding: '8px 4px' }}>—</div>
                )}
                {dayBks.map(b => (
                  <div
                    key={b.id}
                    className={`ev ev-week ${colourFor(b, isFirstForCustomer(b))}`}
                    style={{ marginBottom: 6, cursor: 'pointer' }}
                    data-testid={`week-ev-${b.id}`}
                    onClick={(e) => { e.stopPropagation(); onOpenBooking?.(b.id); }}
                  >
                    <div className="ev-head">
                      <BookingPill booking={b} testIdSuffix={b.id} />
                    </div>
                    <b>{fmtTime(b.starts_at)} · {b.customer?.name}</b>
                    <small>{b.service?.name} · {b.barber?.name?.split(' ')[0]}</small>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
